import React from "react"
import { auditShape } from "utils/propTypeShapes"
import TaskLink from "../TaskLink"

const TaskExportedInFormSubmissionAuditItemDetails = ({ audit }) => {
  const { formSubmissionSlug, task } = audit

  return (
    <div>
      Exported task <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} /> in an export of submission.
    </div>
  )
}

TaskExportedInFormSubmissionAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default TaskExportedInFormSubmissionAuditItemDetails
